module.exports = __webpack_public_path__ + "assets/1577fbd8596b8d93a7fec2c7c17e2327.png";